import type { DataMode } from "@/constants";
import { FAMILY } from "@/settings/widgetFamilies";

const settings = {
  scenarioId: {
    default: "",
    type: "select",
    label: "Scenario",
    dictionary: "scenarios",
    gridPosition: [0, 0],
  },
  planMarketsFirst: {
    default: true,
    type: "checkbox",
    label: "List Scenario Markets First",
    gridPosition: [1, 0],
  },
};

export default {
  family: [FAMILY.OTHER],
  recommendedFamily: [FAMILY.OTHER],
  name: "traditionalRadioViabilityTable",
  title: "Radio - Market Viability Score",
  defaultHeight: 8,
  planOnly: true,
  dataModes: ["project"] as DataMode[],
  settings,
  planSettings: settings,
};
